// Events B3b (#687): a ticket checkout the server refused because the seats are gone.
// The client switches on the error CODE (`details.code === 'SOLD_OUT'`), never on message text.

interface SoldOutShape {
  response?: { data?: { details?: { code?: string } } };
}

/** True when the server refused the checkout with 409 SOLD_OUT. */
export function isSoldOutError(error: unknown): boolean {
  return (error as SoldOutShape | null | undefined)?.response?.data?.details?.code === 'SOLD_OUT';
}

/** What a buyer may still pick: the order caps, narrowed to the seats left (null = no limit). */
export function capToSeats(max: number, seatsRemaining: number | null | undefined): number {
  return seatsRemaining == null ? max : Math.max(0, Math.min(max, seatsRemaining));
}
